import React from 'react';
import { TextField, FormControl, InputLabel, Grid, Checkbox, FormControlLabel } from '@mui/material';
import { ChromePicker } from 'react-color';
import { host } from '../../../supabaseClient';

const GeneralInfoForm = ({ id, name, color, isDemo, isSimpleMode, setName, setLogo, logoFile, setLogoFile, setIconFile, setColor, setIsDemo, setIsSimpleMode }) => {
  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleLogotipoFileChange = (event) => {
    setLogoFile(event.target.files[0]);
  };

  const handleIconFileChange = (event) => {
    setIconFile(event.target.files[0]);
  };
  
  const handleColorChange = (selectedColor) => {
    setColor(selectedColor.hex);
  };

  const handleDemoChange = (event) => {
    setIsDemo(event.target.checked);
  };

  const handleSimpleModeChange = (event) => {
    setIsSimpleMode(event.target.checked);
  };

  return (
    <Grid container spacing={2} mt={2}>
      <Grid item md={12}>
        <TextField
          label="Nombre de la empresa"
          value={name}
          onChange={handleNameChange}
          required
          fullWidth
        />
      </Grid>
      <Grid item md={12}>
        Logo
        <FormControl fullWidth>
          <input
            id="logotipo-input"
            type="file"
            accept="image/*"
            onChange={handleLogotipoFileChange}
          />
        </FormControl>

        <img height={'60px'} src={host + '/storage/v1/object/public/logos/' + id + '.png'}/>

      </Grid>
      <Grid item md={12}>
        Logo icono
        <FormControl fullWidth>
          <input
            id="icon-input"
            type="file"
            accept="image/*"
            onChange={handleIconFileChange}
          />
        </FormControl>

        <img height={'60px'} src={host + '/storage/v1/object/public/icons/' + id + '.png'}/>

      </Grid>
      <Grid item md={12}>
        <InputLabel htmlFor="logotipo-input">Color</InputLabel>
        <ChromePicker
          color={color}
          onChange={handleColorChange}
        />
      </Grid>
      <Grid item md={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isDemo}
              onChange={handleDemoChange}
              color="primary"
            />
          }
          label="Demo"
        />
        <span style={{ fontSize: '0.8rem' }}>Este modo se utilizará para dar una demo.</span>
      </Grid>
      <Grid item md={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isSimpleMode}
              onChange={handleSimpleModeChange}
              color="primary"
            />
          }
          label="Modo Simple"
        />
        <span style={{ fontSize: '0.8rem' }}>Este modo desactivará actividades, certificados y el inicio de sesión.</span>
      </Grid>
    </Grid>
  );
};

export default GeneralInfoForm;
